export default __webpack_public_path__ + "assets/images/6b9bb0e85bddde097b39fac6fbd585d0.jpg";